function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { toKebabCase } from './case';
export function compose(parent, child) {
    return {
        $key: function(kebabCase) {
            var parentKey = parent.$key(kebabCase);
            var seprator = kebabCase ? '' : '.';
            var value = parentKey ? "".concat(parent.$key(kebabCase)).concat(seprator).concat(child.$key(kebabCase)) : child.$key(kebabCase);
            return kebabCase ? toKebabCase(value) : value;
        },
        $get: function(s) {
            return child.$get(parent.$get(s));
        },
        $set: function(y, s) {
            return parent.$set(child.$set(y, parent.$get(s)), s);
        }
    };
}
export function lensProp(name) {
    return {
        $key: function() {
            return name.toString();
        },
        $get: function(s) {
            return s[name];
        },
        $set: function(a, s) {
            return _object_spread_props(_object_spread({}, s), _define_property({}, name, a));
        }
    };
}
export function lensIndex(i) {
    return {
        $key: function() {
            return "[".concat(i, "]");
        },
        $get: function(xs) {
            return xs[i];
        },
        $set: function(x, xs) {
            return xs.map(function(old, ci) {
                return ci === i ? x : old;
            });
        }
    };
}
var idLens = {
    $key: function() {
        return '';
    },
    $get: function(s) {
        return s;
    },
    $set: function(s) {
        return s;
    }
};
export function lensProxy() {
    var parent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : idLens;
    return new Proxy(parent, {
        get: function get(target, key) {
            if (key in target) return target[key];
            var composedItem = compose(parent, Number(key) === +key ? lensIndex(+key) : lensProp(key));
            return lensProxy(composedItem);
        }
    });
}
